/**
 * Website Theme Loader
 * Version: 1.0.0
 *
 * Dynamically loads palette CSS based on theme-config.js
 *
 * Philosophy (CLAUDE.md):
 * - Simple, event-driven, single path
 * - No setTimeout, no race conditions
 * - Trust the framework (Vite handles dynamic imports)
 * - If import fails, fix the palette file (don't add workarounds)
 *
 * How it works:
 * 1. Read palette name from THEME_CONFIG
 * 2. Vite resolves dynamic import at build time
 * 3. CSS injected into <head> automatically
 * 4. HMR updates live during development
 *
 * NO fallback logic - if palette doesn't exist, build should fail.
 * This forces us to fix the problem (create the palette) instead of hiding it.
 */

import { THEME_CONFIG } from './theme-config.js';

/**
 * Load palette CSS dynamically
 * Vite resolves this at build time, NOT runtime
 */
const loadPalette = async () => {
  const paletteName = THEME_CONFIG.palette;

  try {
    // Vite dynamic import - resolves at build time
    await import(`./website/palettes/website-palette-${paletteName}.css`);

    if (import.meta.env.DEV) {
      console.info(`[Theme] ✅ Palette loaded: ${paletteName}`);
    }
  } catch (error) {
    // NO FALLBACK - fail loudly so we fix the issue
    console.error(`[Theme] ❌ Failed to load palette: ${paletteName}`);
    console.error('[Theme] Available palettes: default, logo, earth, example');
    console.error('[Theme] Check: frontend/src/website/palettes/website-palette-${paletteName}.css exists');
    throw error; // Let build fail - forces us to create the palette
  }
};

// Execute immediately
loadPalette();
